var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leimonRobot padding80"},[_c('Header',{attrs:{"current":0}}),_c('LeiMonContent',{attrs:{"LeiMonContent":_vm.LeiMonContent}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }